import { v4 as uuidv4 } from 'uuid';

import actions from './actions.mjs';
import config from './config.mjs';
import {
  KEY_ACTION_NAME,
  KEY_CONFIG_ID,
  KEY_CONFIG_REVISION,
  KEY_EVENT_ID,
  KEY_PARENT,
  KEY_UUID
} from './constants.mjs';
import { createQueryEvaluator, evaluateQueryValue } from './query.mjs';

function evaluateActions(actions, actionName, actionData, extendedData) {
  const queryEvaluator = createQueryEvaluator(
    actionName,
    actionData,
    extendedData
  );

  for (let i = 0; i < actions.length; i++) {
    const {
      key: augmentActionName,
      condition: query,
      id: event_id
    } = actions[i];

    const value = evaluateQueryValue(query, queryEvaluator);

    if (value === undefined) continue;

    extendedData[KEY_ACTION_NAME] = augmentActionName;
    extendedData[KEY_EVENT_ID] = event_id;

    for (let j = 0; j < actions[i].properties.length; j++) {
      const { key, ...query } = actions[i].properties[j];

      const value = evaluateQueryValue(query, queryEvaluator);

      if (value !== undefined) {
        extendedData[key] = value;
      }
    }
  }
}

export function augmentAction(actionName, actionData) {
  const extendedData = {};

  if (actions.error) {
    console.error('WoopraAugmentActionError', actions.error); // eslint-disable-line no-console
  } else {
    evaluateActions(actions, actionName, actionData, extendedData);

    const {
      [KEY_ACTION_NAME]: extendedActionName,
      [KEY_EVENT_ID]: event_id,
      ...extendedProperties
    } = extendedData;

    if (extendedActionName) {
      const uuid = uuidv4();
      const { id: config_id, revision: config_revision } = config.meta;

      actionData[KEY_UUID] = uuid;
      actionData[KEY_CONFIG_ID] = config_id;
      actionData[KEY_CONFIG_REVISION] = config_revision;
      actionData[KEY_EVENT_ID] = event_id;
      actionData[KEY_PARENT] = true;

      this.track(
        extendedActionName,
        {
          ...actionData,
          ...extendedProperties,
          [KEY_PARENT]: false
        },
        { queue: true }
      );
    }
  }
}
